<!-- this field is optional -->
<template>
  <div class="form__group--border pt-32 pb-16">
    <fieldset>
      <legend class="form__label pb-8">{{ legend }}</legend>
      <ul>
        <li v-for="option in options" :key="option.value">
          <PoppinsCheckbox
            v-model="qualifications"
            :labelName="option.optionText"
            :aria-label="generateScreenReaderLabel(option.optionText)"
            :value="option.value"
          />
        </li>
      </ul>
    </fieldset>
  </div>
</template>

<script lang="ts">
import Checkbox from '@/components/checkbox/Checkbox.vue';

export default {
  name: 'QualificationsCheckbox',
  components: {
    PoppinsCheckbox: Checkbox,
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
    generateScreenReaderLabel: {
      type: Function,
      required: true,
    },
    legend: {
      type: String,
      required: true,
    },
  },
  computed: {
    qualifications: {
      get() {
        return this.$store.getters.getFormField('qualifications');
      },
      set(newValue) {
        return this.$store.dispatch('updateForm', { key: 'qualifications', value: newValue });
      },
    },
  },
};
</script>
